export const isFactorTrendMetric = (selectedMetrics: string[] = []) => {
  const factorTrendMetrics: string[] = [
    'factorContributionToRiskTrend',
    'factorContributionToReturnTrend',
    'factorExposuresTrend',
  ];
  return selectedMetrics?.length === 1 && factorTrendMetrics.includes(selectedMetrics[0]!);
};
